window.getBucketItemTemplate = (item) => {
    return `
        <li data-bucket-id="${item.id}">
            <a href="/planifier/poi/${item.id}" target="_blank">
                <div class="img-container" style="background-image: url(${item.thumbnail})">
                    <div class="flag-container">
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="69" viewBox="0 0 48 69">
                            <path d="M0-10H48V59L24.2,49,0,59Z" transform="translate(0 10)" fill="${window.getColorHex(item.category)}"/>
                        </svg>
                        <div class="flag-content">
                            ${window.getCategoryIcon(item.category)}
                            <span>${item.grade}</span>
                        </div>
                    </div>
                </div>
                <div class="title-container">
                    <span class="poi-title">${item.title}</span>
                    <span class="poi-state">${item.state}</span>
                </div>
            </a>
        </li>
    `;
}